module.exports = {
    bind: function() {
        var $tabs = $(this.el).find('div');
        $tabs.click(function(event) {
            var $this = $(this);
            var currentTab = $this.attr('data-tab');

            $tabs.removeClass('active');

            $this.addClass('active');

            $('.tab').hide();

            $(".tab[data-tab='" + currentTab + "']").show();
        });
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/directives/tabs.js